import React, {FC, useEffect, useMemo, useState} from 'react'
import {KTSVG} from '../../../helpers'
import {useNotifications} from '../../../../app/modules/context/types'

const capitalizeFirstLetter = (value: string) => {
    if (!value) {
        return value
    }

    return value.charAt(0).toUpperCase() + value.slice(1)
}

const Toast: FC = () => {
    const {toast: {type, text: {message, title}}, setToast} = useNotifications()
    const [visible, setVisible] = useState<boolean>(!!type)

    useEffect(() => {
        if (!type) {
            return
        }

        setVisible(true)

        const hideTimer = setTimeout(() => {
            setVisible(false)

            const clearTimer = setTimeout(() => {
                setToast((prev) => ({
                    ...prev,
                    type: '',
                }))
            }, 300)

            return () => clearTimeout(clearTimer)
        }, 3000)

        return () => clearTimeout(hideTimer)
    }, [setToast, type])

    const styles = useMemo(() => {
        const isSuccess = type === 'success'

        return {
            background: isSuccess ? 'linear-gradient(90deg, #e8fff3 30%, #aefcd4 100%)' : 'linear-gradient(90deg, #fff5f8 30%, #fcbfd1 100%)',
            className: isSuccess ? 'success' : 'danger',
            icon: isSuccess ? '/general/gen048.svg' : '/general/gen050.svg',
        }
    }, [type])

    if (!type) {
        return null
    }

    return (
        <div
            className="card"
            style={{
                background: styles.background,
                position: 'fixed',
                right: 0,
                top: 0,
                transform: `translateX(${visible ? '-10%' : '100%'}) translateY(65px) scale(${visible ? 1 : 0.95})`,
                opacity: visible ? 1 : 0,
                zIndex: 9999,
                backdropFilter: 'blur(10px)',
                minWidth: 350,
                maxWidth: 500,
                transition: 'transform .3s ease, opacity .2s ease',
            }}
        >
            <div className="card-body p-2 p-sm-3">
                <div className="d-flex flex-wrap flex-sm-nowrap">
                    <div
                        className={`d-flex flex-center flex-shrink-0 rounded w-30px h-30px w-sm-40px h-sm-40px me-5 border border-1 border-${styles.className}`}
                        style={{background: '#ffffff80'}}
                    >
                        <KTSVG
                            path={`/media/icons/duotune${styles.icon}`}
                            className={`svg-icon svg-icon-2x svg-icon-${styles.className}`}
                        />
                    </div>
                    <div className="d-flex flex-column">
                        <div className="d-flex align-items-center mb-1">
                            <span className={`text-${styles.className} fs-6 fs-sm-5 fw-bolder`}>{title}</span>
                        </div>
                        <div className="d-flex flex-wrap fw-bold fs-7 fs-sm-8 text-gray-700">
                            {capitalizeFirstLetter(message)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export {Toast}
